export enum AddPhotoTheme {
  SmallWithAvatar = 'smallWithAvatar',
  WithBoxLoaderOnInit = 'withBoxLoaderOnInit',
  WithBarLoaderOnInit = 'withBarLoaderOnInit',
}
